import BrandConfigurationReportTableData from "./BrandConfigurationReportTableData";
import BrandConfigurationReportTableFilter from "./BrandConfigReportTableFilterCard";

const tableHeadings = {
  brand: "Brand",
  backend_interface_name: "Affiliate System",
  ui_site_name: "Website",
  integration_status: "Integration Status",
  stuck_at: "Stuck At",
  reason: "Reason",
  last_run: "Last Run",
  action: "Action",
};

const BrandConfigurationReportTable = () => {
  return (
    <>
      <BrandConfigurationReportTableFilter />
      <BrandConfigurationReportTableData tableHeadings={tableHeadings} />
    </>
  );
};

export default BrandConfigurationReportTable;
